module.exports = __webpack_public_path__ + "img/tu1.852d1ec2.png";